import { render, staticRenderFns } from "./ByAwsAgreement.vue?vue&type=template&id=5afb426c&scoped=true&"
import script from "./ByAwsAgreement.vue?vue&type=script&lang=js&"
export * from "./ByAwsAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afb426c",
  null
  
)

export default component.exports